import * as Yup from "yup";

export const groupObject = {
  id: "",
  categoryName: "",
  categoryTitle: "",
};

export function objectFromResponseData(responseData) {
  return {
    id: responseData.id,
    categoryName: responseData.category_name,
    categoryTitle: responseData.category_title,
  };
}

export const validationSchema = Yup.object().shape({
  categoryName: Yup.string().required("Group Name is required."),
  categoryTitle: Yup.string().required("Group Title is required."),
});
